import httpClient from '../httpClient';

const post = async (data) => {
	return await httpClient.post(`${process.env.REACT_APP_API_HOST}/rol_icfes/`, data);
};

const getAll = async () => {
  return (await httpClient.get(`${process.env.REACT_APP_API_HOST}/rol_icfes/`).then(res => res.data));
};

const get = async (id) => {
  return await httpClient.get(`${process.env.REACT_APP_API_HOST}/rol_icfes/${id}/`);
};

const put = async (id, data) => {
  return await httpClient.put(`${process.env.REACT_APP_API_HOST}/rol_icfes/${id}/`, data);
};

const remove = async (id) => {
  return await httpClient.delete(`${process.env.REACT_APP_API_HOST}/rol_icfes/${id}`);
};

export {
  post,
  getAll,
  get,
  put,
  remove
}
